// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__3POw1","Open":"SideDrawer_Open__3zuig","Close":"SideDrawer_Close__21FaP","Logo":"SideDrawer_Logo__X3ZsN"};